<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="设备ID" prop="deviceId" >
        <a-input v-model="form.deviceId" placeholder="请输入设备ID" />
      </a-form-model-item>
      <a-form-model-item label="灯光开关：1开 0关" prop="switchOn" >
        <a-input v-model="form.switchOn" placeholder="请输入灯光开关：1开 0关" />
      </a-form-model-item>
      <a-form-model-item label="色温模式：1冷光 2暖光 3白光" prop="colorMode" >
        <a-input v-model="form.colorMode" placeholder="请输入色温模式：1冷光 2暖光 3白光" />
      </a-form-model-item>
      <a-form-model-item label="亮度模式：1白天 2夜间" prop="brightnessMode" >
        <a-input v-model="form.brightnessMode" placeholder="请输入亮度模式：1白天 2夜间" />
      </a-form-model-item>
      <a-form-model-item label="亮度值0-100" prop="brightness" >
        <a-input v-model="form.brightness" placeholder="请输入亮度值0-100" />
      </a-form-model-item>
      <a-form-model-item label="色温值(K)" prop="colorTemperature" >
        <a-input v-model="form.colorTemperature" placeholder="请输入色温值(K)" />
      </a-form-model-item>
      <a-form-model-item label="进出灯光提示：1开 0关" prop="entryLightTip" >
        <a-input v-model="form.entryLightTip" placeholder="请输入进出灯光提示：1开 0关" />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getLightSetting, addLightSetting, updateLightSetting } from '@/api/mibo/lightSetting'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,

        deviceId: null,

        switchOn: null,

        colorMode: null,

        brightnessMode: null,

        brightness: null,

        colorTemperature: null,

        entryLightTip: null,

        createTime: null,

        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        deviceId: [
          { required: true, message: '设备ID不能为空', trigger: 'blur' }
        ],
        switchOn: [
          { required: true, message: '灯光开关：1开 0关不能为空', trigger: 'blur' }
        ],
        colorMode: [
          { required: true, message: '色温模式：1冷光 2暖光 3白光不能为空', trigger: 'blur' }
        ],
        brightnessMode: [
          { required: true, message: '亮度模式：1白天 2夜间不能为空', trigger: 'blur' }
        ],
        brightness: [
          { required: true, message: '亮度值0-100不能为空', trigger: 'blur' }
        ],
        colorTemperature: [
          { required: true, message: '色温值(K)不能为空', trigger: 'blur' }
        ],
        entryLightTip: [
          { required: true, message: '进出灯光提示：1开 0关不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        deviceId: null,
        switchOn: null,
        colorMode: null,
        brightnessMode: null,
        brightness: null,
        colorTemperature: null,
        entryLightTip: null,
        createTime: null,
        remark: null,
      }
                                  },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getLightSetting({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateLightSetting(this.form).then(response => {

              if(response.success) {
                this.$message.success('修改成功',3)
                this.open = false
                this.$emit('ok')
              } else {
                let messageInfo = response.message || response.msg || '修改失败';
                this.$message.error(messageInfo);
              }

            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addLightSetting(this.form).then(response => {
              if(response.success) {
                this.$message.success('新增成功',3)
                this.open = false
                this.$emit('ok')
              } else {
                let messageInfo = response.message || response.msg || '新增失败';
                this.$message.error(messageInfo);
              }

            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
